import { render, staticRenderFns } from "./ModalUploadAttachment.vue?vue&type=template&id=059fea74"
import script from "./ModalUploadAttachment.vue?vue&type=script&lang=js"
export * from "./ModalUploadAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports